import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environmentLoader } from 'ecova-environment-loader';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// @ts-ignore
import envSettings from './assets/environments/environment.json';
const envUrl = 'assets/environments/environment.json';

if (!environment.local) {
  localStorage.removeItem('ecova_token');
}

environment.settings = envSettings;

// @ts-ignore
try {
  window['idToken'] = JSON.parse(localStorage.getItem('okta-token-storage')).idToken.idToken;
} catch (e) {
  console.log('error: ', e);
}

environmentLoader(envUrl).then(env => {
  environment.settings = env;
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
});
